import React from 'react';
import './projects.scss';

import {handleAuthError, useCheckUserAuthentication,fetchLookup, IsRole_OfficeAuditor} from '../../globals';

import projectDetail from './projectDetail.js';
import {commessaStatoOptions,statusCommessaProgress} from '../../globals';

//import CashFlow from './cashFlow.js';

import { createStore } from 'devextreme-aspnet-data';
import { useState, useEffect } from "react";
import Button from 'devextreme-react/button';
import {Popup} from 'devextreme-react/popup';

import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';

import DataGrid, {
  Column,
 // Export,
  MasterDetail,
  Format,
  //Popup,
  Form,
  //Button,
  Pager,
  Paging,
 // FilterRow,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Summary,
  Toolbar,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';


import { Item} from 'devextreme-react/form';
 const readOnlyEditorOptions = { disabled: true};

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Commesse'

export default function Projects(props) {

  var prjDataGridRef = React.createRef();

  const dataInizio = props.dataInizio;
  const dataFine = props.dataFine;
 
  const isInCompanyManage = props.isInCompanyManage ? props.isInCompanyManage : false;

  const intermediarioId = isInCompanyManage? props.intermediario : 210;

  //const urlLoad = isInCompanyManage? serviceUrl2 + '/GetCompanyManagementProjects': serviceUrl2 + '/Find'
  const urlLoad = isInCompanyManage? serviceUrl2 + '/GetCompanyManagementRealProjects': serviceUrl2 + '/Find'

  const [clienti, setClienti] = useState({});
  const [collaboratori, setCollaboratori] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [currentDocNo, setCurrentDocNo] = useState();
  const [currentRow, setCurrentRow] = useState(1);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [anni, setAnni] = useState({});

  const [availableTransitions, setAvailableTransitions] = useState([]);

  const [annoFilter, setAnnoFilter] = useState(new Date().getFullYear());
  const [intermediarioFilter, setIntermediarioFilter] = useState(intermediarioId);
  const [statoFilter, setStatoFilter] = useState();
  const [isStorico, setIsStorico] = useState(false);

  const filterPayload = { 
    storico: isStorico,
    anno: annoFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    fromDate: dataInizio,
    toDate: dataFine
  };

  const user = useCheckUserAuthentication();

  const notesEditorOptions = { height: 38 };

  const isOfficeAuditor = IsRole_OfficeAuditor();

  const remoteDataSource = createStore({

    key: 'id',
    //loadUrl: serviceUrl2 + '/Find',
    loadUrl: urlLoad,
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
        var payload = ajaxOptions.data;
        payload.values = JSON.stringify(filterPayload);
        ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  useEffect(() => {

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl2 =  newServiceUrl2 + "/GetClienti";

    const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
    var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";

    const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

    const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniCommesse';
    var newUrl9 =  newServiceUrl9 + "/GetAction";

    const fetchData = async () => {

      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const json2 = await fetchLookup(newUrl2,requestOptions);
        if (json2) {
          setClienti(json2);
        }

        // const response2 = await fetch(newUrl2,requestOptions);
        // const json2 = await response2.json();
        // console.log(json2);
        // setClienti(json2);

        const json3 = await fetchLookup(newUrl3,requestOptions);
        if (json3) {
          setCollaboratori(json3);
        }
        
        // const response3 = await fetch(newUrl3,requestOptions);
        // const json3 = await response3.json();
        // console.log(json3);
        // setCollaboratori(json3);

        const json7 = await fetchLookup(newUrl7,requestOptions);
        if (json7) {
          setIntermediari(json7);
        }
        
        // const response7 = await fetch(newUrl7,requestOptions);
        // const json7 = await response7.json();
        // console.log(json7);
        // setIntermediari(json7);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        //console.log(json9);
        setAnni(json9);

      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
    }, [user?.token]); // Aggiorna se il token cambia

  const loadTransitions = async (projectId) => {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN 
      + `/api/Commessa/GetAvailableTransitions/${projectId}`;

    const requestOptions = {
      headers: {
        Authorization: `Bearer ${user.token}`
      }
    };

    const response = await fetch(url, requestOptions);
    const json = await response.json();

    setAvailableTransitions(json);
  }

  const changeState = async (transitionId) => {

  console.log("Transizione: " + transitionId); 
  const url = process.env.REACT_APP_WEBAPP_DOMAIN
   + `/api/commessa/changeStatus/${currentRow}`;

  const requestOptions = {

    method: 'POST',

    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.token}`
    },

    body: JSON.stringify({
      transitionId: transitionId
    })
  };

  const response = await fetch(url, requestOptions);
  const data = await response.json();

  notify(data.message, data.success ? 'success' : 'error', 2000);

  refreshDataGrid();

  await loadTransitions(currentRow);
  prjDataGridRef.instance().repaint();
}

  const onToolbarPreparing = (e) => {

    const toolbarItems = e.toolbarOptions.items;

    availableTransitions.forEach(t => {

      const btnIcon = t.statoToId > t.statoFromId
      ? "chevrondoubleright"
      : "chevrondoubleleft";

      toolbarItems.unshift({
        location: "after",
        widget: "dxButton",
        options: {
          //text: t.azione,
          type: "default",
          //icon: btnIcon,
          color: t.colore,
          disabled: !isRowSelected,
          elementAttr: {
          style: `background-color:${t.colore}; border-color:${t.colore}; color:white`
          },

          template: function(data, container) {

            container.style.display = "flex";
            container.style.alignItems = "center";

            const text = document.createElement("span");
            text.innerText = t.azione;

            const iconEl = document.createElement("i");
            iconEl.className = `dx-icon dx-icon-${btnIcon}`;

            if (btnIcon === "chevrondoubleright") {
              iconEl.style.marginLeft = "6px";
              container.append(text,iconEl);
            } else {
              iconEl.style.marginRight = "6px";
              container.append(iconEl,text);
            }

          },

          onClick: () => changeState(t.id)
        }
      });

    });

  };

  function refreshDataGrid() {
    prjDataGridRef.instance().refresh();
  }

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentRow(data.id);
      setCurrentDocNo(data.numero);
      setIsRowSelected(true);
      
      loadTransitions(data.id);

    } else{
      setIsRowSelected(false);
    }
  }

  function customizeText(data) {
    return `Commesse: ${data.value}`;
  }

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuova Commessa'
  };

  const selectBoxOptions = {
    width: 150,
    items: anni,
    valueExpr: 'id',
    displayExpr: 'annoDoc',
    onValueChanged: (args) => {
      setAnnoFilter(args.value);
    },
    value: annoFilter
    };
  
  const selectBoxOptions2 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
    };

  const aggiornaMovimenti= (idCommessa, mode) => {
    
    var path = "";
    if(mode === 1)
      path = '/api/Commessa/UpdatePaymentMovements/';
    else if(mode === 2)
      path = '/api/Commessa/UpdateProceedsMovements/';
    
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + path + idCommessa;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };
    
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
      })
      .catch(error => { notify(error, 'error', 5000); }); 
    }




  function updateMovs() {
    let result = confirm("<i>Aggiornare i Pagamenti della commessa selezionata?</i>", "Aggiorna Pagamenti");
      result.then((dialogResult) => {
      if  (dialogResult) {
        aggiornaMovimenti(currentRow,1);
      }  
    });
  };

  function updateMovs2() {    
    let result = confirm("<i>Aggiornare gli Incassi della commessa selezionata?</i>", "Aggiorna Incassi");
      result.then((dialogResult) => {
      if  (dialogResult) {
        aggiornaMovimenti(currentRow,2);
      }  
    });
  };

  function onRowInserting(e) {
    e.data.createBy = user.name;
    e.data.management = 0;
  };

  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
  };

  const onCellPrepared = (e) => {
    if (e.rowType === "data") {
      if (e.column.dataField === "statoId") {  
        if (e.data.statoId === 0)
          e.cellElement.style.cssText = "color: white; background-color: green";
        else if  
          (e.data.statoId === 1)
        e.cellElement.style.cssText = "color: white; background-color: red";
      }
    }
  }


  return (
    <React.Fragment>
      { !isInCompanyManage &&  <h2 className={'content-block'}>Commesse</h2> }
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
       
        <DataGrid id="grid-container"
          ref={ref => prjDataGridRef = ref}
          className={'dx-card wide-card'}
          dataSource={remoteDataSource}
          showBorders={true}

          onSelectionChanged={onRowSelectionChanged}
          //onRowExpanded={onRowExpanded}
          //onEditingStart={onEditingStart}
          //onRowRemoving={onRowRemoving}
          //onEditorPreparing={onEditorPreparing}
          //onExporting={onExporting}
          //onCellPrepared={onCellPrepared}
          onRowUpdating={onRowUpdating}
          onRowInserting={onRowInserting}
          onCellPrepared={statusCommessaProgress}
          onToolbarPreparing={onToolbarPreparing}
        >
         
        { !isInCompanyManage
        &&   
          <Toolbar>
          
            <Item name="addRowButton"  options={addButtonOptions} location="before"/>
            <Item location="before">
              <Button className="offer-toolbar"
                icon='refresh'
                hint='Aggiorna'
                onClick={refreshDataGrid} 
                />
            </Item>
            <Item location="before">
              <Button className="offer-toolbar"
                icon='showpanel'
                hint='Aggiorna Pagamenti'
                onClick={updateMovs} 
                disabled={!isRowSelected}
                />
            </Item>
            <Item location="before">
              <Button className="offer-toolbar"
                icon='hidepanel'
                hint='Aggiorna Incassi'
                onClick={updateMovs2} 
                disabled={!isRowSelected}
                />
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>

            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>
            
            <Item name="searchPanel" className="offer-toolbar"/>
          
          </Toolbar>
        }

          <HeaderFilter visible={true} />
          <Summary>
            <TotalItem
                column="codice"
                summaryType="count"
                customizeText={customizeText}
            />
          </Summary>
          <Selection mode="single" />

          <Editing
            mode="popup"
            allowUpdating={!isOfficeAuditor}
            allowAdding={!isOfficeAuditor}
            allowDeleting={!isOfficeAuditor}
            useIcons={true}
          >
          
          <Popup title="Offerta" showTitle={true} width={1200} height={780} />
            <Form>
           
              <Item itemType="group" caption="Dati Identificativi" colCount={4} colSpan={2}>
               
                <Item dataField="codice" colSpan={2} disabled={false}/>
                <Item dataField="nome"colSpan={2} />
                <Item dataField="dataInizio"colSpan={2} isRequired= "true"/>
                <Item dataField="dataFinePrevista"colSpan={2}/>
                <Item dataField="dataFineEffettiva"colSpan={2}/>
                <Item dataField="statoId" colSpan={2} isRequired= "true" editorOptions={readOnlyEditorOptions}/>
                <Item
                  dataField="descrizione"
                  editorType="dxTextArea"
                  colSpan={4}
                  editorOptions={notesEditorOptions} />
                <Item dataField="clienteId" colSpan={2} isRequired= "true"/>
                <Item dataField="intermediarioId" colSpan={2} isRequired= "true"/>
                <Item dataField="projectManagerId" colSpan={2} isRequired= "true"/>
                <Item dataField="assistentePMId" colSpan={2} isRequired= "true"/>
                <Item dataField="referenteTecnicoId" colSpan={2} isRequired= "true"/>
 
              </Item>  
              
            </Form>
          </Editing>
              

          <Column dataField="id" visible={false}/>
          <Column dataField="codice" caption="Codice" width={110}/>
          <Column dataField="nome" caption="Nome" />
          <Column dataField="dataInizio" dataType="date" format= {'dd/MM/yyyy'} caption="Data inizio" width={130}/>
          <Column dataField="dataFinePrevista" dataType="date" format= {'dd/MM/yyyy'} caption="Data Fine Prevista" width={150} visible={false} />
          <Column dataField="dataFineEffettiva" dataType="date" format= {'dd/MM/yyyy'} caption="Data Fine" width={130} />
          <Column dataField="descrizione" caption="Descrizione" visible={false}/>
          <Column dataField="clienteId" caption="Cliente" >
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="projectManagerId" caption="PM" >
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="assistentePMId" caption="Assist. PM" visible={false}>
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="intermediarioId" caption="Azienda" width={240} visible={false}>
            <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
           <Column dataField="referenteTecnicoId" caption="Referente Tecnico" width={240} visible={false}>
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="statoId"  width={110} caption="Stato">
            <Lookup dataSource={commessaStatoOptions} displayExpr="desc" valueExpr="id" />
          </Column>

          <MasterDetail
          enabled={true}
          component={projectDetail}
        />
        </DataGrid>


        </div>
      </div>
    </React.Fragment>
  )
};

